export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";